import { create } from 'zustand';

export type WorkflowWizardStep = 'select-preset' | 'upload' | 'processing' | 'review' | 'confirm' | 'complete';

interface AiWorkflowState {
  activeSessionId: number | null;
  currentStep: WorkflowWizardStep;
  selectedPresetId: number | null;
  selectedPresetName: string;
  inputType: string;
  targetRecordType: string;
  extractedData: Record<string, unknown> | null;
  validationErrors: string[];
  isProcessing: boolean;
  error: string | null;
}

interface AiWorkflowActions {
  setActiveSession: (id: number | null) => void;
  setCurrentStep: (step: WorkflowWizardStep) => void;
  selectPreset: (id: number, name: string, inputType: string, targetRecordType: string) => void;
  setExtractedData: (data: Record<string, unknown> | null) => void;
  setValidationErrors: (errors: string[]) => void;
  setIsProcessing: (processing: boolean) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

const initialState: AiWorkflowState = {
  activeSessionId: null,
  currentStep: 'select-preset',
  selectedPresetId: null,
  selectedPresetName: '',
  inputType: '',
  targetRecordType: '',
  extractedData: null,
  validationErrors: [],
  isProcessing: false,
  error: null,
};

export const useAiWorkflowStore = create<AiWorkflowState & AiWorkflowActions>((set) => ({
  ...initialState,
  setActiveSession: (id) => set({ activeSessionId: id }),
  setCurrentStep: (step) => set({ currentStep: step }),
  selectPreset: (id, name, inputType, targetRecordType) => set({
    selectedPresetId: id,
    selectedPresetName: name,
    inputType,
    targetRecordType,
    currentStep: 'upload',
  }),
  setExtractedData: (data) => set({ extractedData: data }),
  setValidationErrors: (errors) => set({ validationErrors: errors }),
  setIsProcessing: (processing) => set({ isProcessing: processing }),
  setError: (error) => set({ error }),
  reset: () => set(initialState),
}));
